export const getDirectNotificationRecipientsPending = () => ({
    type: 'GET_DIRECT_NOTIFICATION_RECIPIENTS_PENDING'
});

export const getDirectNotificationRecipientsSuccess = recipients => ({
    type: 'GET_DIRECT_NOTIFICATION_RECIPIENTS_SUCCESS',
    recipients
});

export const getDirectNotificationRecipientsError = error => ({
    type: 'GET_DIRECT_NOTIFICATION_RECIPIENTS_ERROR',
    error
});

export const sendDirectNotificationPending = () => ({
    type: 'SEND_DIRECT_NOTIFICATION_PENDING'
});

export const sendDirectNotificationSuccess = result => ({
    type: 'SEND_DIRECT_NOTIFICATION_SUCCESS',
    result
});

export const sendDirectNotificationError = error => ({
    type: 'SEND_DIRECT_NOTIFICATION_ERROR',
    error
});

export const clearDirectNotificationStatus = () => ({
    type: 'CLEAR_DIRECT_NOTIFICATION_STATUS'
});

const headers = () => ({
    'Content-Type': 'application/json; charset=UTF-8',
    'Authorization': sessionStorage.getItem('agronetToken'),
    'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
});

export const getDirectNotificationRecipients = () => {
    return dispatch => {
        dispatch(getDirectNotificationRecipientsPending());

        fetch(`${process.env.REACT_APP_API_URL}/direct_notifications/recipients`, {
            method: 'GET',
            headers: headers()
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                }
                dispatch(getDirectNotificationRecipientsError(`Error: ${res.status} ${res.statusText}`));
                return null;
            })
            .then(res => {
                if (res) {
                    dispatch(getDirectNotificationRecipientsSuccess(res));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
                dispatch(getDirectNotificationRecipientsError(err.message));
            });
    };
};

export const sendDirectNotification = ({title, message, recipientUserIds}) => {
    return dispatch => {
        dispatch(sendDirectNotificationPending());

        fetch(`${process.env.REACT_APP_API_URL}/direct_notifications/send`, {
            method: 'POST',
            headers: headers(),
            body: JSON.stringify({
                title,
                message,
                recipientUserIds,
                sendToAll: false
            })
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                }
                dispatch(sendDirectNotificationError(`Error: ${res.status} ${res.statusText}`));
                return null;
            })
            .then(res => {
                if (res) {
                    dispatch(sendDirectNotificationSuccess(res));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
                dispatch(sendDirectNotificationError(err.message));
            });
    };
};
